import React, { useState, useRef } from "react";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardActionArea from "@mui/material/CardActionArea";
import "./card.css";

const Cards = (props) => {
  const [url, desc] = [props.url, props.desc];
  const modalRef = useRef();
  const openHandler = () => {
    console.log("ref ", modalRef.current);
    modalRef.current.style.display = "block";
  };
  return (
    <>
      <Card
        id={props.filename}
        sx={{
          width: { xs: props.mobWidth, md: props.width },
          height: props.height,
          position: "relative",
        }}
        onClick={() => {
          openHandler();
        }}
      >
        <CardActionArea>
          <CardMedia
            component="img"
            image={url}
            alt="green iguana"
            className="image-zoom"
          />
        </CardActionArea>
      </Card>
      <>
        <div class="modal" ref={modalRef}>
          <span
            class="close"
            onClick={() => {
              modalRef.current.style.display = "none";
            }}
          >
            &times;
          </span>
          <img class="modal-content" alt="zoom" src={url} />
          <div id="caption"></div>
        </div>
      </>
    </>
  );
};
export default Cards;
